import React, {useState, useRef, useEffect} from "react";


const DragDropFile = (
    {
        handleChange,
        handleClick = () => {},
        title,
        fileTypes = []
    }
) => {
    const [file, setFile] = useState('');
    const [dragging, setDragging] = useState(false);
    const drop = useRef();

    useEffect(() => {
        drop.current.addEventListener('dragover', handleDragOver);
        drop.current.addEventListener('dragenter', handleDrag);
        drop.current.addEventListener('dragleave', handleDrag);
        drop.current.addEventListener('drop', handleDrop);

        return () => {
            drop.current.removeEventListener('dragover', handleDragOver);
            drop.current.removeEventListener('dragenter', handleDrag);
            drop.current.removeEventListener('dragleave', handleDrag);
            drop.current.removeEventListener('drop', handleDrop);
        };
    }, []);

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrag = function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter") {
            setDragging(true);
        } else if (e.type === "dragleave") {
            setDragging(false);
        }
    };
    
    const fileParsingSend = (file) => {
        handleChange({
            file: file,
            fileName: file.name,
            fileType: file.type
        });
    }

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setDragging(false);

        const {files} = e.dataTransfer;

        if (files && files.length) {
            fileParsingSend(files[0]);
            setFile(files[0]);
            handleClick();
        }
    };

    const Change = (e) => {
        const {files} = e.target;

        if (files && files.length) {
            fileParsingSend(files[0]);
            setFile(files[0]);
            e.target.value = '';
        }
    }

    return <div className="DragDropFile">
            <label ref={drop} className={`DragDropFile__uploader ${dragging ? 'dragging' : ''}`}>
                <input type="file" name="file" accept={fileTypes.join()} onChange={Change} onClick={handleClick} />
            </label>
            <div className="DragDropFile__plaseholder">
                <div className="mb-1">
                    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="64" height="64">
                        <path fill="#263238" fillOpacity=".5" d="M1.816 15.556v.002c0 1.502.584 2.912 1.646 3.972s2.472 1.647 3.974 1.647a5.58 5.58 0 0 0 3.972-1.645l9.547-9.548c.769-.768 1.147-1.767 1.058-2.817-.079-.968-.548-1.927-1.319-2.698-1.594-1.592-4.068-1.711-5.517-.262l-7.916 7.915c-.881.881-.792 2.25.214 3.261.959.958 2.423 1.053 3.263.215l5.511-5.512c.28-.28.267-.722.053-.936l-.244-.244c-.191-.191-.567-.349-.957.04l-5.506 5.506c-.18.18-.635.127-.976-.214-.098-.097-.576-.613-.213-.973l7.915-7.917c.818-.817 2.267-.699 3.23.262.5.501.802 1.1.849 1.685.051.573-.156 1.111-.589 1.543l-9.547 9.549a3.97 3.97 0 0 1-2.829 1.171 3.975 3.975 0 0 1-2.83-1.173 3.973 3.973 0 0 1-1.172-2.828c0-1.071.415-2.076 1.172-2.83l7.209-7.211c.157-.157.264-.579.028-.814L11.5 4.36a.572.572 0 0 0-.834.018l-7.205 7.207a5.577 5.577 0 0 0-1.645 3.971z"/>
                    </svg>
                </div>
                <span>{file.name ? file.name : title}</span>
            </div>
        </div>
};


export default DragDropFile;